import {DeleteOutlined, EditOutlined, PlusCircleOutlined} from "@ant-design/icons";
import {Col, Form, Layout, Popconfirm, Row, Spin, Tooltip,Breadcrumb} from "antd";
import "antd/dist/antd.min.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRequest, postRequest } from "../../axios";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import unverifybtn from "../../image/unverify.png";
import verifybtn from "../../image/verifybtn.png";
import "../../styles/Main.scss";
import {ErrorNotificationMsg, SuccessNotificationMsg} from "../../utils/Notifications";
const { Content } = Layout;

const SuperUserList = () => {

    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);
    const [totalCount, settotalCount] = useState(0);
    const [manageUserStep, setEmployeeList] = useState([]);

    //State Initiailisation
    const [state, setState] = useState({
        page: 1,
        ordering: "id",
        pagesize: 10,
        search: "",
        total: 0,
    });

    // Function to fetch the list of employees by company ID
    const EmployeeListGetById = async () => {
        setLoading(true);

        try {
            let apiResponse = await getRequest(
                `employee/get-company-employees/`
            );
            if (apiResponse.data.results.success) {
                setEmployeeList(apiResponse.data.results.data);
                settotalCount(apiResponse.data.count);
            } else {
                ErrorNotificationMsg(t("error_in_list_prapproval_hierarchy"));
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    // useEffect to fetch employee list when reload or state changes
    useEffect(() => {
        EmployeeListGetById();
    }, [reload, state]);

    // Function to handle archiving (deleting) an employee by ID
    const handleArchive = async (id) => {
        try {
            let apiResponse = await postRequest("employee-delete/", {
                deleted: [id], // wrap the id in an array
            });
            if (apiResponse.data.success) {
                let totalArchive = totalCount - 1; // assuming totalCount is the total count of items

                if (totalArchive < 11) {
                    setState((prevState) => ({
                        ...prevState,
                        page: 1,
                        search: "",
                    }));
                    setReload(!reload);
                } else {
                    setReload(!reload);
                }
                SuccessNotificationMsg(apiResponse.data.message);
            } else {
                if (Array.isArray(apiResponse.data.message)) {
                    ErrorNotificationMsg(apiResponse.data.message.join(", "));
                } else {
                    ErrorNotificationMsg(apiResponse.data.message);
                }
            }
        } catch (error) {
            setState((prevState) => ({
                ...prevState,
                page: 1,
                search: "",
            }));
        }
    };

    return (
        <>
 <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
              
                <h3>Manage User</h3>
    
                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </Breadcrumb.Item>
    
                  <Breadcrumb.Item>Manage User</Breadcrumb.Item>
                </Breadcrumb>
                </div>
              <div className="pgnmbtns">
 <Tooltip placement="topLeft" title="Archived Records">
                  <Link to="/superuser/archive" className="Archiveicon" >
                    <Archiveicon />
                  </Link>
                </Tooltip>
              </div>
              
            </div>
          </div>
            <Content className="stepscontentwrap">
             
              <div className="stepsContent">

                <Spin spinning={loading}>
                  <div className="cardswraper">
                    <Row gutter={24}>

                      <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                        <div className="stepcard addsite">
                          <div>
                            <Link to="/superuser/add">
                              <PlusCircleOutlined />
                            </Link>
                            <h5>Add User</h5>
                          </div>
                        </div>
                      </Col>
                        {manageUserStep.map((user) => (
                            <Col xs={24} sm={24} md={12} xl={8} xxl={6} key={user.id}>
                              <div className="stepcard sitecard">
                                <div className="cardtitle ">
                                  <div>
                                      {user.status === "active" ? (
                                          <img src={verifybtn} alt="company" />
                                      ) : (
                                          <img src={unverifybtn} alt="company" />
                                      )}
                                      {user.first_name} {user.last_name}

                                  </div>
                                  <div className="action">
                                    <Link to={`/superuser/edit/${user.id}`}>
                                      <EditOutlined />
                                    </Link>
                                    <Popconfirm
                                        className="action"
                                        title={t("pop_title")}
                                        okText={t("pop_ok")}
                                        cancelText={t("pop_cancel")}
                                        onConfirm={() => handleArchive(user.id)}
                                    >
                                      <DeleteOutlined />
                                    </Popconfirm>
                                  </div>
                                </div>
                                <Row gutter={16}>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>Employee ID</label>
                                      <span className="value">{user.employe_id}</span>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>Contact Number </label>
                                      <span className="value">{user.phone}</span>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>Role </label>
                                      <span className="value">
                                  {user.groups
                                      .map((group) => group.role_name)
                                      .join(", ")}
                                </span>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={12}>
                                    <Form.Item>
                                      <label>Email </label>
                                      <span className="value">{user.email}</span>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                        ))}
                    </Row>
                  </div>
                </Spin>
              </div>
            </Content>
  
        </>
    );
};

export default SuperUserList;
